import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/app/shared/lib/utils';

const buttonVariants = cva(
	// 'text-bottomDialogButton inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',

	'inline-flex items-center justify-center whitespace-nowrap  rounded-lg text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
	{
		variants: {
			variant: {
				primary:
					'bg-gradient-to-b bg-primary-btn-gradient text-primary-foreground shadow-lg',
				secondary:
					'border-gradient-r-primary-secondary-gray-900 gradient-border-2',
				destructive:
					'bg-destructive text-destructive-foreground hover:bg-destructive/90',
				arrow: '',
				claim: 'bg-gradient-to-b from-green-500 to-green-700 bg-green-700 text-xs rounded-lg animate-bounce duration-1000 box-shadow-lg px-3',
				inviteFriends:
					'flex text-sm rounded-lg text-white flex-1 shadow-lg border-gradient-tr-invite-friends-gray-900 gradient-border-2 gap-2',

				// outline: 'rounded-lg bg-bottom-dialog-button w-full',
				// gradientBorder:
				// 	'w-full text-xl rounded-2xl shadow-lg py-6 bg-customer-700 text-white border-gradient-tr-invite-friends-gray-900 gradient-border-2 gap-2',
				// secondary:
				// 	'bg-blue-500 hover:bg-accent text-xl rounded-2xl bg-gradient-to-r from-customer-500 to-customer-300',
				// ghost: 'hover:bg-accent hover:text-accent-foreground',
				// link: 'text-primary underline-offset-4 hover:underline',
				//
				// copyToClipBoard: 'flex text-sm rounded-lg shadow-lg text-white border-gradient-tr-invite-friends-gray-900 gradient-border-2 gap-2'
			},
			size: {
				default: 'py-4 w-full',
				sm: 'py-2 px-3 rounded-md',
				lg: 'py-6 px-4 rounded-md',
				icon: 'rounded-lg h-[55px] w-[55px]',
			},
		},
		defaultVariants: {
			variant: 'primary',
			size: 'default',
		},
	}
);

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof buttonVariants> {
	asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ className, variant, size, asChild = false, ...props }, ref) => {
		const Comp = asChild ? Slot : 'button';
		return (
			<Comp
				className={cn(buttonVariants({ variant, size, className }))}
				ref={ref}
				{...props}
			/>
		);
	}
);
Button.displayName = 'Button';

export { Button, buttonVariants };
